import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../theme';

interface CounterCardProps {
  count: number;
  title: string;
  subtitle: string;
  footnote: React.ReactNode;
  counterRef?: React.RefObject<HTMLDivElement | null>;
}

export const CounterCard: React.FC<CounterCardProps> = ({
  count,
  title,
  subtitle,
  footnote,
  counterRef,
}) => {
  return (
    <Box
      ref={counterRef}
      sx={{
        backgroundColor: colors.deepNavy,
        borderRadius: '16px',
        padding: { xs: '32px 24px', md: '48px' },
        marginBottom: '48px',
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: '1.25rem', md: '1.5rem' },
          fontWeight: 600,
          color: colors.pureWhite,
          marginBottom: '16px',
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: '3rem', md: '4rem' },
          fontWeight: 700,
          color: colors.signalOrange,
          lineHeight: 1,
          marginBottom: '8px',
        }}
      >
        {count}
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: '1.25rem', md: '1.5rem' },
          fontWeight: 600,
          color: colors.pureWhite,
          marginBottom: '16px',
        }}
      >
        {subtitle}
      </Typography>
      <Typography
        sx={{
          color: colors.slate[400],
          fontSize: { xs: '0.875rem', md: '1rem' },
        }}
      >
        {footnote}
      </Typography>
    </Box>
  );
};
